import { number } from '@/shared/libs/yup/index';

export const numberOrEmpty = () => number().nullable().transform((value, originalValue) => originalValue === '' ? null : value);